<template>
    <div class="w-full">
        <div class="w-full mb-3 flex justify-content-between gap-2 flex-wrap">
            <Button label="Сбросить" icon="pi pi-refresh" severity="secondary" class="p-button-sm border-round-md border-0 text-xs font-medium" @click="resetFilters" />
        </div>

        <DataTable
            ref="dt"
            :value="rates"
            v-model:filters="localFilters"
            responsiveLayout="scroll"
            filterDisplay="menu"
            lazy
            paginator
            :rows="lazyParams.rows"
            :first="lazyParams.first"
            :rowsPerPageOptions="[10, 20, 50, 100]"
            :totalRecords="totalRecords"
            :loading="loading"
            @page="onPage"
            @sort="onSort"
            @filter="onFilter"
        >
            <Column field="from" sortable filterField="from" :showFilterMatchModes="false">
                <template #header>
                    <span class="text-xs font-medium">From</span>
                </template>
                <template #filter="{ filterModel, filterCallback }">
                    <InputText v-model="filterModel.value" class="p-column-filter w-10rem" placeholder="Например, USD" @keydown.enter="filterCallback()" />
                </template>
                <template #body="{ data }">
                    <span class="text-sm font-medium uppercase">{{ data.from }}</span>
                </template>
            </Column>

            <Column field="to" sortable filterField="to" :showFilterMatchModes="false">
                <template #header>
                    <span class="text-xs font-medium">To</span>
                </template>
                <template #filter="{ filterModel, filterCallback }">
                    <InputText v-model="filterModel.value" class="p-column-filter w-10rem" placeholder="Например, RUB" @keydown.enter="filterCallback()" />
                </template>
                <template #body="{ data }">
                    <span class="text-sm font-medium uppercase">{{ data.to }}</span>
                </template>
            </Column>

            <Column field="parse_type" sortable>
                <template #header>
                    <span class="text-xs font-medium">Источник</span>
                </template>
                <template #body="{ data }">
                    <Tag :value="data.parse_type || '-'" severity="info" class="text-xs" />
                </template>
            </Column>

            <Column field="last_value" sortable>
                <template #header>
                    <span class="text-xs font-medium">Последнее значение</span>
                </template>
                <template #body="{ data }">
                    <span class="text-sm">{{ formatValue(data.last_value) }}</span>
                </template>
            </Column>

            <Column field="created_at" sortable>
                <template #header>
                    <span class="text-xs font-medium">Создан</span>
                </template>
                <template #body="{ data }">
                    <span class="text-xs">{{ formatDate(data.created_at) }}</span>
                </template>
            </Column>

            <Column field="updated_at" sortable>
                <template #header>
                    <span class="text-xs font-medium">Обновлен</span>
                </template>
                <template #body="{ data }">
                    <span class="text-xs">{{ formatDate(data.updated_at) }}</span>
                </template>
            </Column>

            <Column field="actions">
                <template #header>
                    <span class="text-xs font-medium">Действия</span>
                </template>
                <template #body="{ data }">
                    <Button label="График" icon="pi pi-chart-line" class="p-button-sm border-round-md border-0 text-xs font-medium" @click="$emit('open', data)" />
                </template>
            </Column>

            <template #empty>
                <div class="py-4 text-center text-sm text-500">Курсы не найдены</div>
            </template>

            <template #footer>
                <span class="text-sm text-600 font-medium">Всего {{ totalRecords }} курсов</span>
            </template>
        </DataTable>
    </div>
</template>

<script>
import Helper from '@/assets/js/helper.js'

const getDefaultFilters = () => ({
    from: { value: '', matchMode: 'contains' },
    to: { value: '', matchMode: 'contains' },
})

export default {
    props: {
        rates: {
            type: Array,
            default: () => []
        },
        totalRecords: {
            type: Number,
            default: 0
        },
        loading: {
            type: Boolean,
            default: false
        },
        defaultParams: {
            type: Object,
            default: () => ({})
        }
    },
    emits: ['filter', 'lazyParams', 'open'],
    data() {
        return {
            lazyParams: {
                first: this.defaultParams.first ?? 0,
                rows: this.defaultParams.rows ?? 10,
                sort: this.defaultParams.sort ?? { field: '_id', order: -1 },
                sortField: this.defaultParams.sortField ?? '_id',
                sortOrder: this.defaultParams.sortOrder ?? -1,
                filters: this.defaultParams.filters ?? getDefaultFilters(),
            },
            localFilters: this.defaultParams.filters ?? getDefaultFilters(),
        }
    },
    methods: {
        formatDate(value) {
            return this.helper.formatDate(value)
        },
        formatValue(value) {
            if (value === null || value === undefined || value === '') return '-'
            return value
        },
        resetFilters() {
            const filters = getDefaultFilters()
            this.localFilters = filters
            this.lazyParams.filters = filters
            this.lazyParams.first = 0
            this.$emit('filter', filters)
        },
        onPage(event) {
            this.lazyParams.first = event.first
            this.lazyParams.rows = event.rows
            this.$emit('lazyParams', { ...this.lazyParams })
        },
        onSort(event) {
            this.lazyParams.sortField = event.sortField
            this.lazyParams.sortOrder = event.sortOrder
            this.lazyParams.sort = event.sortField ? { field: event.sortField, order: event.sortOrder } : {}
            this.$emit('lazyParams', { ...this.lazyParams })
        },
        onFilter(event) {
            this.localFilters = event.filters
            this.lazyParams.filters = event.filters
            this.lazyParams.first = 0
            this.$emit('filter', event.filters)
        },
    },
    beforeCreate() {
        this.helper = new Helper()
    }
}
</script>